import angular from 'angular';
import businessEmailMailHeader from './businessEmailMailHeader';

export default angular
  .module('businessEmailMailTemplates.components', [])
  .component('businessEmailMailHeader', businessEmailMailHeader).name;
